import { queryOptions } from '@tanstack/react-query';

import { subscriptionApi } from './subscription.api';

export const queryKeys = {
    all: ['subscription'] as const,
    me: () => [...queryKeys.all, 'me'] as const,
    usageHistory: () => [...queryKeys.all, 'usage-history'] as const,
    paidPlans: () => [...queryKeys.all, 'paid-plans'] as const,
};

export function subscriptionMeOptions() {
    return queryOptions({
        queryKey: queryKeys.me(),
        queryFn: ({ signal }) => subscriptionApi.getMe(signal),
        staleTime: 0,
        refetchOnWindowFocus: true,
    });
}

export function subscriptionUsageHistoryOptions() {
    return queryOptions({
        queryKey: queryKeys.usageHistory(),
        queryFn: ({ signal }) => subscriptionApi.getUsageHistory(signal),
    });
}

export function paidPlansOptions() {
    return queryOptions({
        queryKey: queryKeys.paidPlans(),
        queryFn: ({ signal }) => subscriptionApi.getPaidPlans(signal),
        staleTime: 5 * 60 * 1000,
    });
}
